import { ActionTypes } from '../constants/index';

export const getSupportInfo = (payload: any) => ({
  type: ActionTypes.SUPPORT_INFO_LIST_REQUEST,
  payload,
});
